import { render, staticRenderFns } from "./BankRedirect.vue?vue&type=template&id=252fa26a&scoped=true&"
import script from "./BankRedirect.vue?vue&type=script&lang=js&"
export * from "./BankRedirect.vue?vue&type=script&lang=js&"
import style0 from "./BankRedirect.vue?vue&type=style&index=0&id=252fa26a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252fa26a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
